import React, {Children, Component} from 'react';
import classNames from 'classnames';

import styles from './List.less';

export default class List extends Component {
	render() {
		const {
			children,
			className,
			isHorizontal,
			align,
			...props
		} = this.props;

		const ul_styles = classNames(styles['list'], className, {
			[styles['list_horizontal']]: isHorizontal,
			[styles['list_align_right']]: align === 'right',
		});

		return (
			<ul className={ul_styles} {...props}>
				{Children.toArray(children).map(item => (
					<li key={item.key} className={styles['list__item']}>
						{item}
					</li>
				))}
			</ul>
		);
	}
}